module.exports = __webpack_public_path__ + "img/SKMJ_install1.f257b21f.png";